<template>
  <div class="wrapper wrapper-content animated fadeInRight articleList">
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" v-if="$data.rows">
              <div class="col-xs-12">{{ $data.rows.length }}{{ $t("message.datagridresult") }}</div>
              <datatable :columns="columns" :data="$data.rows">
                <template scope="{ row }">
                  <tr :style="trStyle">
                    <td align="center">
                      <select-row :row="row"></select-row>
                    </td>
                    <td>
                      <a :href="`./#/main/eightCentresContentDetail?refId=${row.id}`">{{ row.content }}</a>
                    </td>
                    <td>
                      <span>{{ row.createdTime }}</span>
                    </td>
                  </tr>
                </template>
              </datatable>
              <datatable-pager align="right" :style="navStaty" :per-page="per_page" type="short" v-model="page"></datatable-pager>
            </div>
            <div class="col-sm-12" style="margin-top: -30px">
              <div class="pull-right">
                <button class="btn btn-white" @click="gotoDetail">{{ $t("message.Add") }}</button>
                <button class="btn btn-white" @click="showWarning">{{ $t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import selectall from "../components/common/selectAll";
import selectrow from "../components/common/selectRow";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "eightCentresContent",
  mixins: [config.globalMixin],
  components: {
    "select-row": selectrow,
    "select-all": selectall,
  },
  data() {
    return {
      page: 1,
      per_page: 20,
      filter: "",
      superLength: 0,
      superFalg: true,
      trStyle: {
        cursor: "pointer",
      },
      navStaty: {
        "margin-top": "-30px",
        "margin-bottom": "15px",
        "margin-right": "30px",
      },
      columns: [],
      rows: null,
      refId: null,
      centres: [],
      selected_rows: [],
      searchName: "",
      searchStatus: null,
    };
  },
  created: function () {
    eventBus.$on(
      "selected",
      function (row) {
        if (this.selected_rows.indexOf(row) === -1) {
          this.selected_rows.push(row);
        }
      }.bind(this),
    );

    eventBus.$on(
      "deselected",
      function (row) {
        if (this.selected_rows.indexOf(row) !== -1) {
          let index = this.selected_rows.indexOf(row);
          this.selected_rows.splice(index, 1);
        }
      }.bind(this),
    );

    eventBus.$on(
      "select-all",
      function (selected) {
        Vue.set(this, "selected_rows", this.rows.slice(0));
      }.bind(this),
    );

    eventBus.$on(
      "deselect-all",
      function (selected) {
        Vue.set(this, "selected_rows", []);
      }.bind(this),
    );
  },
  methods: {
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return d + "/" + MM + "/" + y + " " + h + ":" + m + ":" + s;
    },
    //    async init() {
    //   try {
    //     console.log('init called');

    //     let resp;
    //     try {
    //       resp = await this.$store.dispatch("eightCentres/searchDetail", {});
    //       console.log('searchDetail raw return:', resp);
    //     } catch (err) {
    //       console.error('searchDetail action threw:', err);
    //       this.rows = [];
    //       return;
    //     }

    //     // adapt this check to the actual response shape you saw in Network
    //     const resultArray = (resp && resp.data && resp.data.result) ? resp.data.result
    //                       : (resp && resp.result) ? resp.result
    //                       : null;

    //     if (!resultArray) {
    //       console.warn('searchDetail returned no result array', resp);
    //       this.rows = [];
    //       return;
    //     }

    //     // map and set rows (simple mapping)
    //     this.rows = resultArray.map(item => ({
    //       ...item,
    //       centreName: item.centreName || `Centre ${item.refId || '-'}`,
    //       createdTime: item.createdTime || item.createdAt || item.createTime || null,
    //       id: item.id || `${item.refId || 'unknown'}-${item.createdTime || Date.now()}`
    //     }));

    //     console.log('this.rows set to', this.rows);
    //   } catch (e) {
    //     console.error('init error', e);
    //     this.rows = [];
    //   }
    // }
    // ,

    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/eightCentresContentDetail" });
    },
    datataleCli(row) {
      this.$router.push({
        path: "/main/eightCentresContentDetail",
        query: { id: row.id },
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.selected_rows.length != 0) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [
            {
              name: this.$i18n.t("message.Confirm"),
              callBack: function () {
                that.deleteList();
              },
            },
            {
              name: this.$i18n.t("message.Cancel"),
              callBack: function () {
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              },
            },
          ],
        });
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj;
      if (this.selected_rows.length != 0) {
        for (let i = 0; i < this.selected_rows.length; i++) {
          ids.push(this.selected_rows[i].id);
        }
      }
      objdata.articleIds = ids;

      let data = await this.$store.dispatch("deleteArticle", this.setFormData(objdata));
      if (data.data.errorCode === 0) {
        this.selected_rows = [];
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: [],
        });
        this.init();
      }
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    async publish(row) {
      var that = this;
      let objdata = that.getAuthObj;
      objdata.articleIds = row.id;
      let data = await that.$store.dispatch("publishArticle", that.setFormData(objdata));
      if (data) {
        row.statusName = this.$i18n.t("message.Published");
        row.status = 10;
      }
    },
    async publishEvent(row) {
      var that = this;
      this.$store.commit("setwarning", {
        string: this.$i18n.t("message.Are you sure to publish"),
        boolean: true,
        button: [
          {
            name: this.$i18n.t("message.Confirm"),
            callBack: function () {
              that.publish(row);
            },
          },
          {
            name: this.$i18n.t("message.Cancel"),
            callBack: function () {
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            },
          },
        ],
      });
    },
    async previewEvent(row) {
      var rnd = Date.now();
      this.$store.commit("setmagazine", {
        id: row.id,
        rnd: rnd,
        boolean: true,
      });
    },
    async readyToPublish(row) {
      var that = this;
      let objdata = that.getAuthObj;
      objdata.articleIds = row.id;
      let data = await that.$store.dispatch("readyToPublishArticle", that.setFormData(objdata));
      if (data) {
        row.statusName = this.$i18n.t("message.Ready to Publish");
        row.status = 1;
      }
    },
    async readyToPublishEvent(row) {
      var that = this;
      this.$store.commit("setwarning", {
        string: this.$i18n.t("message.Are you sure to readyToPublish"),
        boolean: true,
        button: [
          {
            name: this.$i18n.t("message.Confirm"),
            callBack: function () {
              that.readyToPublish(row);
            },
          },
          {
            name: this.$i18n.t("message.Cancel"),
            callBack: function () {
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            },
          },
        ],
      });
    },
    async edit(row) {
      var that = this;
      let objdata = that.getAuthObj;
      objdata.articleIds = row.id;
      let data = await that.$store.dispatch("offlineArticle", that.setFormData(objdata));
      if (data) {
        row.statusName = this.$i18n.t("message.Draft");
        row.status = 0;
      }
    },
    async editEvent(row) {
      var that = this;
      this.$store.commit("setwarning", {
        string: this.$i18n.t("message.Are you sure to edit"),
        boolean: true,
        button: [
          {
            name: this.$i18n.t("message.Confirm"),
            callBack: function () {
              that.edit(row);
            },
          },
          {
            name: this.$i18n.t("message.Cancel"),
            callBack: function () {
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            },
          },
        ],
      });
    },
    setColumns: function () {
      this.columns = [
        {
          label: "",
          align: "center",
          component: selectrow,
          headerComponent: selectall,
        },
        { label: this.$i18n.t("message.Centres Name"), field: "centreName" },
        { label: this.$i18n.t("message.createdTime"), field: "createdTime" },
      ];
    },

    async loadCentres() {
      const self = this;
      let obj = this.getAuthObj;
      obj.startRow = 0;
      obj.maxRows = 10000;
      obj.bannerName = this.searchName;
      try {
        const { data } = await this.$store.dispatch("eightCentres/ifDetailExist", obj);
        self.rows = data.result;
      } catch (err) {
        console.error("loadCentres error", err);
        self.rows = [];
      }
    },
  },
  mounted() {
    this.setColumns();
    this.loadCentres();
    console.log("initial refId (mounted):", this.refId);
  },
  computed: {
    _language() {
      return this.$store.state.userInfo.langCode;
    },
  },
  watch: {
    selected_rows: function () {
      for (var row of this.rows) {
        if (this.selected_rows.indexOf(row) === -1) {
          return;
        }
      }
      eventBus.$emit("all-selected");
    },
    _language: function () {
      this.setColumns();
    },
  },
};
</script>

<style scoped>
.ui-grid-icon-ok:before {
  content: "\c362";
}
.ui-grid-icon:before,
.ui-grid-icon:before {
  font-family: "ui-grid";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: 0.2em;
}
</style>
